import React from 'react';
import { reduxForm } from 'redux-form';
import * as Forms from './forms';
import * as validate from './syncValidator';

const Headline = ( props ) => <Forms.HeadlineForm { ...props } />;
const Location = ( props ) => <Forms.LocationForm { ...props } />;
const Industry = ( props ) => <Forms.IndustryForm { ...props } />;
const Press = props => <Forms.PressForm { ...props } />;
const Award = props => <Forms.AwardForm { ...props } />;
const Publication = props => <Forms.PublicationForm { ...props } />
const Summary = ( props ) => <Forms.SummaryForm { ...props } />;
const Certificate = props => <Forms.CertificateForm { ...props } />;
const Education = props => <Forms.EducationForm { ...props } />;
const Experience = props => <Forms.ExperienceForm { ... props } />;
const RequestEndorsement = ( props ) => <Forms.RequestEndorsement { ...props } />;

const headline = reduxForm( { form: "headline" } )( Headline );
const location = reduxForm( { form: "location", validate: validate.location } )( Location );
const industry = reduxForm( { form: "industry" } )( Industry );
const press = reduxForm( { form: "press", validate: validate.general } )( Press );
const award = reduxForm( { form: "award", validate: validate.general } )( Award );
const publication = reduxForm( { form: "publication", validate: validate.general } )( Publication );
const summary = reduxForm( { form: "summary" } )( Summary );
const certificate = reduxForm( { form: "certificate", validate: validate.certificates } )( Certificate );
const education = reduxForm( { form: "education", validate: validate.education } )( Education );
const experience = reduxForm( { form: "experience", validate: validate.experience } )( Experience );
const requestEndorsement = reduxForm( { form: "request_endorsement", validate: validate.requestEndorsement })( RequestEndorsement );

export {
    headline,
    location,
    industry,
    summary,
    requestEndorsement,
    press,
    award,
    publication,
    certificate,
    education,
    experience,
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/GenerateForms.js